/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LineErrorResponse } from './';
import {
    LineErrorResponseFromJSON,
    LineErrorResponseFromJSONTyped,
    LineErrorResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface MigrateOrganizationManagerProcessResponse
 */
export interface MigrateOrganizationManagerProcessResponse {
    /**
     * 
     * @type {LineErrorResponse}
     * @memberof MigrateOrganizationManagerProcessResponse
     */
    error?: LineErrorResponse;
}

/**
 * Check if a given object implements the MigrateOrganizationManagerProcessResponse interface.
 */
export function instanceOfMigrateOrganizationManagerProcessResponse(value: object): value is MigrateOrganizationManagerProcessResponse {
    return true;
}

export function MigrateOrganizationManagerProcessResponseFromJSON(json: any): MigrateOrganizationManagerProcessResponse {
    return MigrateOrganizationManagerProcessResponseFromJSONTyped(json, false);
}

export function MigrateOrganizationManagerProcessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateOrganizationManagerProcessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : LineErrorResponseFromJSON(json['error']),
    };
}

export function MigrateOrganizationManagerProcessResponseToJSON(value?: MigrateOrganizationManagerProcessResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'error': LineErrorResponseToJSON(value['error']),
    };
}

